export default __webpack_public_path__ + "static/media/carrinho_de_compras.f22ff022.svg";